import styled from 'styled-components';

export const ChoicesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 48px;
  margin-top: 32px;

  @media ${({ theme }) => theme.device.mobile} {
    grid-gap: 16px;
    margin-top: 40px;
  }
`;
